import { render, staticRenderFns } from "./NominationNewsCard.vue?vue&type=template&id=7a12ca24&scoped=true&"
import script from "./NominationNewsCard.vue?vue&type=script&lang=js&"
export * from "./NominationNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./NominationNewsCard.vue?vue&type=style&index=0&id=7a12ca24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a12ca24",
  null
  
)

export default component.exports